import React, { useEffect } from 'react';
import { useI18n } from 'next-localization';

import { useFormatedSiteTitle } from '@/hooks/use-formatted-site-title';
import { INITIAL_HOST_TITLE } from '@/lib/constants';
import { useOasApp } from '@/providers/oas-app-provider';
import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';

import { SearchBar } from './components/search-bar';
import { ProvidersSearchProps } from './landing-search.types';

// This is because TS compains about coids not found in window object
declare global {
  interface Window {
    coids: string | undefined;
  }
}

export const OASLandingSearch: React.FC<ProvidersSearchProps & { physiciansCount: number }> = ({
  rendering,
}): JSX.Element => {
  const fields = useOasApp();
  const { coids, pageShortDescription } = fields;
  const { t } = useI18n();

  // Exposes coids for easy access in Selenium
  // Todo: move this to data-attr
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.coids = coids;
    }
  }, [coids]);

  const initialHostTitleValue =
    typeof window !== 'undefined' ? sessionStorage.getItem(INITIAL_HOST_TITLE) : '';
  const initialHostTitle = initialHostTitleValue
    ? `${initialHostTitleValue} ${t('OAS.LandingPage.Title')}`
    : '';

  let pageTitleFormatted = useFormatedSiteTitle({ returnType: 'string' }) as string;

  if (initialHostTitle) {
    pageTitleFormatted = initialHostTitle;
  }

  return (
    <>
      <div className="mb-5 py-6 neu-bg-blue-100" data-tests-id={rendering?.componentName}>
        {/* Header container section */}
        <div className="container py-3">
          <div className="d-flex flex-column justify-content-center align-items-center w-100 mb-6">
            <div className="col-12 text-center w-auto">
              <h1 className="mt-1 fw-bold d-none d-lg-block neu-display-title neu-text-main-0">
                {pageTitleFormatted}
              </h1>
              <h4 className="mt-1 fw-bold d-lg-none neu-text-main-0">{pageTitleFormatted}</h4>
            </div>
            <div className="col-12 text-center pt-2 pt-4 w-auto neu-text-main-0">
              <RichText
                tag="p"
                className="neu-display-6"
                field={pageShortDescription}
                editable={false}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Provider (Search 1) and new use my location (Search 2) components */}
      <SearchBar />
    </>
  );
};
